// A missing or provisional grade must never be presented as a failed attempt.
export const numericScore = value => {
  if (!['number', 'string'].includes(typeof value) || (typeof value === 'string' && !value.trim())) return null;
  const score = Number(value);
  return Number.isFinite(score) ? score : null;
};

export const evaluationScore = (evaluation = {}, fallbackScore) => numericScore(
  Object.prototype.hasOwnProperty.call(evaluation, 'total_score')
    ? evaluation.total_score
    : evaluation.score ?? fallbackScore
);

export const isEvaluationPending = (evaluation = {}, fallbackScore) => (
  evaluation.status === 'pending_review' || evaluation.provisional === true ||
  evaluationScore(evaluation, fallbackScore) === null
);
